export enum WorkingDayEnum {
    EmergencyOrder = 0,
    NormalOrder = 1
}